import { combineReducers } from 'redux';
import UnitHome from './UnitHome';
import Ticket from './Ticket';
import TicketPostponeProcess from './TicketPostponeProcess';
import TicketReassignment from './TicketReassignment';

export default combineReducers({
  UnitHome,
  Ticket,
  TicketPostponeProcess,
  TicketReassignment,
});
